import React, {ReactNode} from 'react'

import AppLoaderErrorIndicator from './AppLoaderErrorIndicator'

interface AppLoaderErrorBoundaryProps {
  children: ReactNode
}

interface AppLoaderErrorBoundaryState {
  hasError: boolean
}

/**
 * @description Provides simple error boundary and display for initial app component lazy-load. Works with Suspense.
 */
export class AppLoaderErrorBoundary extends React.Component<AppLoaderErrorBoundaryProps, AppLoaderErrorBoundaryState> {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError(_error: Error) {
    return {hasError: true}
  }

  render() {
    const {hasError} = this.state
    const {children} = this.props

    if (hasError) {
      return <AppLoaderErrorIndicator />
    }

    return children
  }
}

export default AppLoaderErrorBoundary
